import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=e50acb2e&"
import script from "./page-not-found.js?vue&type=script&lang=js&"
export * from "./page-not-found.js?vue&type=script&lang=js&"
import style0 from "./page-not-found.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports